<template>
  <div class="intent_wrapper">
    <div class="title">교재 관리</div>
    <List page="1" />
    <div class="bbox">
      <b-button @click="addBook()">교재추가</b-button>
    </div>
  </div>
</template>

<script>
import List from "@/components/book/List";
export default {
  components: { List },
  mounted() {
    this.$store.state.subtitle = "교재관리";
  },
  methods: {
    addBook() {
      this.$router.push("/admin/book/form");
    },
  },
};
</script>


<style lang="scss" scoped>
.bbox {
  margin-left: 10px;
}

@import "@/styles/_variables.scss";
.intent_wrapper {
  background-color: white;
  border-radius: 5px;
  box-shadow: 3px 3px 3px $gray400;

  margin: 20px;
  padding: 20px;
  .title {
    font-size: 1.2em;
    color: $gray50;
    background-color: $gray600;
    border-radius: 4px;
    padding-bottom: 6px;
  }
  .title::before {
    content: "";
    font-size: 1.5em;
    padding-left: 6px;
    color: $gray50;
  }
  .searchbox {
    margin: 10px 0 10px 0;
    .divider {
    }
  }
  .buttons {
    text-align: right;
    margin: 4px 0 4px 0;
  }

  .nodata {
    text-align: center;
    color: $point1;
  }
}
</style>